// extracted by mini-css-extract-plugin
module.exports = {"root":"CommsTable_root__188Tl","tableRoot":"CommsTable_tableRoot__1TvH4","header":"CommsTable_header__3QZBE","tableTitle":"CommsTable_tableTitle__3Snh3"};